/**
 * Change the type to show the elements list (grid/list/table)
 *
 * @param      {string}  viewType  The kind to show
 */
window.changeViewType = function (viewType = 'grid') {
    if (!viewType) {
        kindShow = 'grid';
    }
    setStorage('viewType', viewType);
    $('#product-list').removeClass('showOnGrid showOnList showOnTable').addClass(`showOn${ucfirst(viewType)}`);
    $('.product-list-view button').removeClass('is-active');
    $(`.product-list-view .${viewType}`).addClass('is-active');

    // mostar ocultar historico de ventas en listado de búsqueda
    if(viewType === 'list') {
        $('#buttonActionMostarHistorico').removeClass('d-none');
    } else {
        $('#buttonActionMostarHistorico').addClass('d-none');
    }
};

$(function () {
    changeViewType(getStorage('viewType'));
    changeCampaingViewType(getStorage('viewType'));
});


// Temporal para la cambiar vista en campañas
window.changeCampaingViewType = function (viewType = 'grid') {
    if (!viewType) {
        kindShow = 'grid';
    }
    // -> Incluir relanzado Isotope

    setStorage('viewType', viewType);
    $('.campaign-list').removeClass('showOnGrid showOnList showOnTable').addClass(`showOn${ucfirst(viewType)}`);
    $('.catalog-list').removeClass('showOnGrid showOnList showOnTable').addClass(`showOn${ucfirst(viewType)}`);
    $('.product-list-view button').removeClass('is-active');
    $(`.product-list-view .${viewType}`).addClass('is-active');    
};
